<template>
  <div class="add-member">
    <ValidationObserver ref="observer">
      <admin-layout title="Add member">
        <form v-on:submit.prevent="addNewMember" class="signin">
          <ValidationProvider
            ref="email"
            rules="required|email"
            v-slot="{ errors, valid, changed }"
          >
            <bg-field :error="errors && errors[0]" label="Email" name="email">
              <bg-input
                :error="errors && errors[0]"
                name="email"
                :valid="changed && valid"
                v-model="user.email"
              />
            </bg-field>
          </ValidationProvider>
          <bg-field label="Role" name="email">
            <bg-select
              :options="options"
              :value="user.role"
              @change="onRoleChange"
            ></bg-select>
          </bg-field>
          <bg-button text="Add member" type="submit" :isLoading="isPosting" />
          <bg-error :error="error" />
        </form>
      </admin-layout>
    </ValidationObserver>
  </div>
</template>

<style scoped>
.account {
  display: flex;
  justify-content: space-between;
}
.display {
  display: none;
}
</style>

<script>
import AdminLayout from "@/layouts/admin";
import BgField from "@/components/bg-field";
import BgInput from "@/components/bg-input";
import BgButton from "@/components/bg-button";
import BgError from "@/components/bg-error";
import BgSelect from "@/components/bg-select";

import API from "@/api";
import { mapState } from "vuex";

export default {
  name: "account",
  components: {
    BgButton,
    BgError,
    AdminLayout,
    BgField,
    BgInput,
    BgSelect,
  },
  data() {
    return {
      error: null,
      isPosting: false,
      user: {
        email: "",
        company_id: "",
        role: { label: "Member", value: "company_member" },
      },
      options: [
        { label: "Admin", value: "company_admin" },
        { label: "Member", value: "company_member" },
      ],
    };
  },
  computed: {
    ...mapState({
      userState: (state) => state.user,
    }),
  },
  async mounted() {
    const data = await API.user.getUser(this.userState.user.id);
    this.user.company_id = data.company.id;
  },
  methods: {
    onRoleChange(newRole) {
      this.user.role = newRole;
    },
    async addNewMember() {
      const res = await this.$refs.observer.validate();
      if (res) {
        this.isPosting = true;
        const payload = {
          email: this.user.email,
          role: this.user.role.value,
          company_id: this.user.company_id,
        };
        const res = await API.user.postUser(payload);
        if (res.errors) {
          if (res.errors.email) {
            this.$refs["email"].setErrors(res.errors["email"]);
          }
          this.isPosting = false;
        } else {
          this.$router.push({ path: `/members/` });
        }
      }
    },
  },
};
</script>
